export default "__VITE_ASSET__TOkxtDaN__"